// Fenêtres de confirmation et d'alerte intégrées à l'interface, à la place
// de window.confirm / window.alert : celles du navigateur rompent le thème et,
// sur téléphone, ressemblent à une alerte système. Même canal que les
// médailles : un événement, écouté par components/DialogHost.js.
export function confirmDialog(message, { okLabel, danger = false } = {}) {
  return new Promise(resolve => {
    window.dispatchEvent(new CustomEvent("pq:dialog", { detail: { kind: "confirm", message, okLabel, danger, resolve } }));
  });
}

export function alertDialog(message) {
  return new Promise(resolve => {
    window.dispatchEvent(new CustomEvent("pq:dialog", { detail: { kind: "alert", message, resolve } }));
  });
}

// Plusieurs issues : chaque choix est { label, value, primary?, danger? }.
// Échap ou un clic à côté rendent null (rien n'est fait).
export function choiceDialog(message, choices) {
  return new Promise(resolve => {
    window.dispatchEvent(new CustomEvent("pq:dialog", { detail: { kind: "choice", message, choices, resolve } }));
  });
}
